import { AfterViewInit, Component, DestroyRef, effect, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { editActionPlann } from 'src/app/shared/constants/obj-constants';
import { ActivatedRoute } from '@angular/router';
import { HuddlesService } from 'src/app/shared/services/huddle/huddles.service';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import * as moment from 'moment';
import * as _ from 'lodash';
import { GlobalFilterService } from 'src/app/shared/services/filters/global-filter.service';
import { AppStateService } from 'src/app/shared/services/helpers/app-state.service';
import { AccountsService } from 'src/app/shared/services/accounts/accounts.service';
import { DatePipe, NgIf, NgFor } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FeedsService } from 'src/app/shared/services/feeds/feeds.service';
import { FormsModule } from '@angular/forms';
import { OverviewTableComponent } from '../../../../../shared/components/score/score-overview/sub-component/overview-table/overview-table.component';
import { LtmsErrorComponent } from '../../../../../shared/components/ltms-error/ltms-error.component';
import { LtmsLoaderComponent } from '../../../../../shared/components/ltms-loader/ltms-loader.component';
import { ActionEditModalComponent } from '../../action-edit-modal/action-edit-modal.component';



@Component({
    selector: 'app-all-action-plans',
    templateUrl: './all-action-plans.component.html',
    styleUrls: ['./all-action-plans.component.scss'],
    providers: [DatePipe],
    imports: [NgIf, FormsModule, NgFor, OverviewTableComponent, LtmsErrorComponent, LtmsLoaderComponent, ActionEditModalComponent]
})
export class AllActionPlansComponent implements OnInit,AfterViewInit {
  @ViewChild('litmussearchdropdown') litmusfeedsearch!: ElementRef;
  destroyRef = inject(DestroyRef)
  actions: string | null = null;

  isFullScreen = false;
  actionFilteredTagFields: any[] = [];
  // new variabled declaretion
  accountId: any = null;
  brandId: any = null;
  brandDetails: any = {}
  actionBrandId: any = null;
  actionBrandDetails: any = {}
  hierarchyStack: any = null;
  managerAccess: any = null;
  actionDetails: any = {}
  fromDate: any = null;
  toDate: any = null;
  actionConfig: any = {}
  managerAccessDetail: any = {};
  managerHasMergeAccess: boolean = false
  tableConfigs: any = {
    textWrap: true,
    isRowEditable: true,
    isExternalSort: true,
    theme: "theme-2"
  }

  actionTable: any = {
    fixedHeader: [],
    header:
      [{
        header: "Smile Champion - (9 & 10 Smile scores)",
        uniqueId: 'tag_meeting_id',//"tag_ltms_huddle_manager_email_address_1",
        width: '200px',
        maxWidth: '200px',
        minWidth: '200px',
        isSortingEnabled: true,
        // isClickable: true,
        style: {
          header: 'flex-start',
          row: 'flex-start',
          textWrap: 'wrap'
        },
        textStyle: {
          whiteSpace: 'wrap'
        }
      },
      {
        header: "Dates",
        uniqueId: "created_date",
        width: '200px',
        maxWidth: '200px',
        minWidth: '200px',
        isSortingEnabled: true,
        // isClickable: true,
        style: {
          header: 'flex-start',
          row: 'flex-start',
          textWrap: 'wrap'
        },
        textStyle: {
          whiteSpace: 'wrap'
        }
      },
      {
        header: "Customer Testimonial/ Success Story",
        uniqueId: "comments",
        width: '700px',
        maxWidth: '700px',
        minWidth: '700px',
        isSortingEnabled: true,
        style: {
          header: 'flex-start',
          row: 'flex-start'
        },
        textStyle: {
          whiteSpace: 'wrap'
        }
      }
      ],
    rows: []
  }
  columns: any = [];

  filters: any = {}

  pagingDetails: any = {
    start: 0,
    end: 0,
    pageSize: 10,
    pageNumber: 1,
    total: 0,
    totalpages: 1
  }
  pagingButtons: any = {
    isNext: false,
    isPrevious: false,
    isLast: false,
    isFirst: false
  }

  isDataAvailable: boolean = false;
  isLoading: boolean = true;
  feedMapping: any = {}

  // action search dropdown variables 
  showFilterFields: boolean = false;
  showSearchList: boolean = false;
  isOptionLoading: boolean = false;
  isSearchEnabled: boolean = false;
  filterLimit: number = 10;
  searchText: any = ''
  searchableFieldList: any = [];
  defaultSearchField: any = {};
  selectedSearchField: any = {};
  actionSearch: any = {
    selectedOption: {},
    selectedFilter: {},
    placeholder: "Please search and select",
    options: [],
  }

  clearField: any = {
    isError: false,
    displayText: 'clear',
    isEnabled: false
  }
  searchResult: any = {}


  // edit modal variables

  showEditModal: boolean = false;
  modalData: any = {}

  constructor(
    private huddleService: HuddlesService,
    private helperSerice: HelpersService,
    private _toast: ToastService,
    private _stateService: AppStateService,
    private _accountsService: AccountsService,
    private _feedService: FeedsService
  ) {
    effect(() => {
      if (this._stateService.initialized()) {
        const state: any = this._stateService.appState()
        if (state && this.checkRequiredPamater(state)) {
          this.fromDate = state.datePicker.startDate;
          this.toDate = state.datePicker.endDate;
          if (this.brandId != state.brandDetails._id) {
            this.accountId = state.accountDetails._id;
            this.brandDetails = state.brandDetails;

            this.brandId = state.brandDetails._id;
            if (state.hierarchyStack && state.hierarchyStack.length) {
              this.hierarchyStack = state.hierarchyStack
              // this.selected_level = state.hierarchyStack[0].field_id;
              // this.selected_value = state.hierarchyStack[0].group_key[0]
            }
            this.managerAccess = this.getManagerAccess(this.brandId)
            this.actionConfig = _.get(this.brandDetails, "action_management_configuration.huddle.modules.actions");
            this.actionBrandId = _.get(this.actionConfig, "config.brand_id");
            if (this.actionBrandId && this.actionBrandId != '') {
              this._accountsService.getBrandDetail(this.actionBrandId).subscribe((response: any) => {
                if (response && response.code == 0 && _.hasIn(response, 'data.brand') && !_.isEmpty(response.data.brand)) {
                  this.managerAccessDetail = this.helperSerice.getLoggedInAccessLevelAndValue();

                  if (this.managerAccessDetail) {
                    this.managerHasMergeAccess = this.huddleService.updateManagerHuddleMergeAccess(this.managerAccessDetail, this.brandDetails);
                  }
                  this.initializeSearch(response.data.brand);
                  this.prepareActionDetails(response.data.brand);
                  this.getActionList()
                }
              })
            }
          } else if (this.actionBrandId && this.actionBrandId != '') {
            this.getActionList()
          }
        }
      }
    })
  }

  ngOnInit() { }

  ngAfterViewInit(): void {
    document.addEventListener('click', (event) => {
      const litmusfeedsearchel: any = document.getElementById('litmusfeedsearch');
      if (litmusfeedsearchel && litmusfeedsearchel != event.target && !litmusfeedsearchel.contains(event.target)) {
        this.showFilterFields = false;
        this.showSearchList = false;
      }
      if (this.litmusfeedsearch && this.litmusfeedsearch.nativeElement !== event.target && !this.litmusfeedsearch.nativeElement.contains(event.target)) {
        this.showFilterFields = false;
        this.showSearchList = false;
      }
    });
  }

  checkRequiredPamater(state: any) {
    if (state && _.hasIn(state, 'brandDetails') && !_.isEmpty(state.brandDetails) && _.hasIn(state, 'datePicker') && !_.isEmpty(state.datePicker) && _.hasIn(state, 'hierarchyStack') && !_.isEmpty(state.hierarchyStack)) {
      return true;
    } else {
      return false
    }
  }


  prepareActionDetails(brandDetails: any) {
    var defaultRatio = 3;
    this.actionDetails.brand = brandDetails;
    this.actionFilteredTagFields=[]
    var fieldDefinitions = _.get(brandDetails, "field_definitions");
     _.each(fieldDefinitions, (fieldsObj) =>{
              if (fieldsObj.download && !fieldsObj.is_deleted && fieldsObj.field_id != "created_date") {
                this.actionFilteredTagFields.push({
                     "field_id": "litmus_processed_data." + fieldsObj.field_id,
                     "name": fieldsObj.name,
                     "download": fieldsObj.download
                 })
              }
             })
    fieldDefinitions = _.filter(fieldDefinitions, (fieldDefinition: any) => {
      return (_.get(fieldDefinition, "visibility_config.list") != false) ? true : false;
    });
    let totalRatio = fieldDefinitions.map((fieldDefinition: any) => {
      if (_.get(fieldDefinition, "cell_ratio.list")) {
        return _.get(fieldDefinition, "cell_ratio.list");
      } else {
        return 0;
      }
    }).reduce((op1: any, op2: any) => {
      return op1 + op2;
    })

    this.actionDetails.editColumnRatio = ((10 - totalRatio) / totalRatio) * 100;
    this.actionDetails.fieldDefinitions = _.map(Helpers.deepClone(fieldDefinitions), (fieldDefinition: any) => {
      fieldDefinition["td_width"] = ((_.get(fieldDefinition, "cell_ratio.list") || defaultRatio) / totalRatio) * 100;
      return fieldDefinition;
    });
    let isEditEnabled: boolean = true;
    this.columns = _.filter(Helpers.deepClone(_.get(brandDetails, "field_definitions")), (field: any) => {
      // let addToHeader:boolean = ((_.get(field, 'custom_parameter_type') == 4 && _.get(field, 'show_in_inbox_detail') && _.get(field, 'group_id')));
      // isEditEnabled = (field.field_id ==="editBtn" && addToHeader);
      return (_.get(field, 'custom_parameter_type') == 4 && _.get(field, 'show_in_inbox_detail') && _.get(field, 'group_id') && _.get(field, 'field_id') != "editBtn");
    });
    
    let headerList = _.map(this.columns, (field: any) => {
      let column: any = {
        header: field.title || field.name,
        uniqueId: field.field_id,
        width: this.getColumnWidth(field),
        maxWidth: this.getColumnWidth(field),
        minWidth: this.getColumnWidth(field),
        isSortingEnabled: false,
        data_type: field.data_type,
        // isClickable: true,
        style: {
          header: 'flex-start',
          row: 'flex-start',
          textWrap:  'wrap'
        },
        textStyle: {
          whiteSpace: 'wrap',
        }
      }
      if (field.isSortable) {
        if (field.data_type == "date") {
          column.sortId = field.field_id + "_in_ms";
          column.sort_order = 'desc';
          this.tableConfigs.defaultSortOnColumn = column;
        }
        column.isSortingEnabled = true;
      }
      return column

    })
    this.tableConfigs.isRowEditable = isEditEnabled;
    this.actionTable.fixedHeader = headerList.splice(0, 2)
    this.actionTable.header = headerList
  }

  getColumnWidth(column: any) {
    if(column.field_id =="tag_ltms_huddle_e4147198-670e-4ced-b98e-fc4679f57d8f81-11"){
      return '270px'
    }else if(column.field_id == "tag_ltms_huddle_e256eace-6abf-4960-a0ea-ec85abd0addd" || column.field_id == "tag_ltms_huddle_e256eace-6abf-4960-a0ea-ec85abd0a47d"){
      return '300px'
    }else if (column.field_id == "tag_ltms_huddle_82797a2f-616e-4f2f-b4ee-808238baf0e89") {
      return '230px'
    } else if (column.field_id == "tag_ltms_huddle_c562e071-08a6-4ac9-9eb5-54ec4b1b48f0_1") {
      return '400px'
    } else if (_.get(column, 'dom_options.type') == "multi-line") {
      return '600px'
    } else if (column.data_type == 'date' || column.field_id == "tag_ltms_huddle_3082eef8-baba-409d-b05e-99e960d760d889-44") {
      return '150px'
    } else {
      return '200px'
    }

    
  }



  initializeSearch(brandDetails) {
    this.isSearchEnabled = false
    if (brandDetails && brandDetails.field_definitions && brandDetails.field_definitions.length) {
      const searchableFieldList = _.filter(brandDetails.field_definitions, (fieldDetail: any) => {
        return _.get(fieldDetail, "search.huddle");
      });

      if (searchableFieldList && searchableFieldList.length) {
        this.searchableFieldList = searchableFieldList
        this.defaultSearchField = searchableFieldList[0];
        this.selectedSearchField = searchableFieldList[0];
        this.actionSearch.selectedFilter = searchableFieldList[0];
        this.actionSearch.placeholder = "Search "+this.selectedSearchField.name
        this.isSearchEnabled = true
      }
    }
  }

  toggleFilterFieldList() {
    this.showSearchList = false;
    if (this.showFilterFields) {
      this.showFilterFields = false;
    } else {
      this.showFilterFields = true;
    }

  }


  changeFilterField(field: any) {
    this.selectedSearchField = field;
    this.actionSearch.placeholder = "Search "+this.selectedSearchField.name
    this.searchText = '';
    this.showFilterFields = false;
  }

  toggleSearchList() {
    this.showFilterFields = false;
    if (this.showSearchList) {
      this.showSearchList = false;
    } else {
      this.showSearchList = true;
      this.actionSearch.placeholder = this.actionSearch.placeholder;
      
      // this.searchText = '';
      this.searchResult = {
        options: [{
          'displayText': "Start typing to search.",
          'text': "Start typing to search.",
          'id': '',
          isError: true
        }]
      }
    }
  }


  searchByField(event: any) {
    this.isOptionLoading = true
    const searchText = event.target.value;
    if (searchText && searchText != "") {
      const fieldId: string = this.selectedSearchField.field_id
      const param = this.getParametersByFilterType({ term: searchText })
      this._feedService.getFeedAndUserfilter(param).pipe(
        takeUntilDestroyed(this.destroyRef)
      ).subscribe((response: any) => {
        this.searchResult = this.processSerchResult(fieldId, response.data);
        this.isOptionLoading = false;
      });

    } else {
      this.searchResult = {
        options: [{
          'displayText': "Start typing to search.",
          'text': "Start typing to search.",
          'id': '',
          isError: true
        }]
      }
      this.isOptionLoading = false;
    }


  }

  getParametersByFilterType(params) {
    var order = 0;
    if (params.term) {
      params.term = params.term.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace('=', "");
    }
    return {
      brand_id: this.actionBrandId, //huddleActionReportVm.brandId,
      from: this.fromDate,
      to: this.toDate,
      limit: this.filterLimit,
      page_number: (params.page) ? params.page : 1,
      search_type: this.selectedSearchField.field_id, // type,
      search_text: (params.term) ? params.term.trim() : params.term,
      custom_filter_list: this.getCustomFilterList()
    }
  }

  getCustomFilterList() {
    var customFilterList: any = [];
    if (this.hierarchyStack && this.hierarchyStack.length) {
      customFilterList = _.map(this.hierarchyStack, (hierarchy: any) => {
        return {
          field: hierarchy.field_id,
          value: hierarchy.group_key[0]
        }
      });
    } else if (this.managerAccessDetail && this.managerAccessDetail.level && this.managerAccessDetail.value) {
      customFilterList.push({
        "field": this.managerAccessDetail.level,
        "value": this.managerAccessDetail.value
      })
    }
    // Remove duplicates based on field
    customFilterList = _.uniq(customFilterList, "field");
    return customFilterList;
  }

  processSerchResult(fieldId: string, data: any) {
    var searchResults: any = [{ name: '', user_id: null }];
    var isPagination = false;
    // this.shouldShowFeedReset = true;
    if (data.code == 0) {
      // data can be in response to user data(eg. name, phone, email) or transaction data(tag_transaction_id etc)
      var options = data.data || data.feed;
      if (options && options.length) {
        searchResults = options;
        isPagination = (options.length < this.filterLimit) ? false : true;
      } else {
        searchResults = [{ name: 'No Results found', user_id: null, isError: true }];
        isPagination = false;
      }
    } else if (data.code == 4001) {
      // Something went wrong
      searchResults = [{ name: '', user_id: null, isError: true }];
    } else if (data.code == 4003) {
      // internal error, search type not supported
      searchResults = [{ name: 'Search type not supported', user_id: null, isError: true }];
    } else if (data.code == 5005) {
      // "Search not available"
      searchResults = [{ name: 'Search not available', user_id: null, isError: true }];
    } else if (data.code == 5000) {
      // "Unknown Exception, exception while performing search"
      searchResults = [{ name: 'Search not available', user_id: null, isError: true }];
    }

    return {
      options: _.map(searchResults, (item) => {
        if (this.isTextStartsWithTag(fieldId)) {
          if (item.feedback_request_data && !item.user_id) {
            return {
              'displayText': item.feedback_request_data[fieldId],
              'text': item.feedback_request_data[fieldId],
              'id': item.feedback_request_data[fieldId],
              isError: (item.isError) ? true : false
            }
          } else {
            return {
              'text': item.name,
              'id': item.user_id,
              isError: (item.isError) ? true : false
            }
          }
        } else {
          return {
            'displayText': item[fieldId],
            'text': (item['name'] ? item['name'] : '') + " " + (item["phone_number"] ? item["phone_number"] : '') + " " + (item["email_address"] ? item["email_address"] : ''),
            'id': item.user_id,
            isError: (item.isError) ? true : false
          }
        }
      }),
      pagination: {
        more: isPagination
      }
    }
  }

  isTextStartsWithTag(text) {
    // regular expression to check for tag_(it refers to transaction details)
    var searchPattern = new RegExp('^tag_');
    return searchPattern.test(text);
  }


  getActionsforSelectedFields(item: any) {
    if (!item.isError) {
      this.pagingDetails.pageNumber = 1
      if (item.id || item.user_id) {
        const selectedFilterType = this.selectedSearchField.field_id
        this.searchText = item.displayText || item.text;
        if (this.isTextStartsWithTag(selectedFilterType)) {
          this.filters.fieldToSearchOn = this.selectedSearchField.field_id;
          this.filters.textToSearch = item.id;
        } else {
          this.filters["userId"] = item.id;
        }
        this.clearField.isEnabled = true;
        this.getActionList()
      } else {
        this.filters["fieldToSearchOn"] = null
        this.filters["textToSearch"] = null;
        this.filters["userId"] = null;
        this.searchText = '';
        this.clearField.isEnabled = false;
        this.getActionList()
      }
      this.showSearchList = false;
      this.showFilterFields = false;
    }
  }



  // This function calls download/initiate_huddle_download API and these are the required params for this API call
  actionResponseDownload(dates?: { startDate: string; endDate: string; }): void {
    const reqBody = {
      brand_id: this.brandId,
      es_index_brand_id: this.actionBrandId,
      from: this.fromDate,
      to: this.toDate,
      filters: [
        {
          is_tag_filter: true,
          key: "tag_private_group_" + this.managerAccessDetail.level,
          value: [this.managerAccessDetail.value],
        },
      ],
      fields: (this.actionFilteredTagFields && this.actionFilteredTagFields.length) ? this.actionFilteredTagFields: [],
      tabName: "actions",

    };

    this.huddleService.huddleDownload(reqBody).subscribe((response: any) => {
      Helpers.smallAlertBox("Success", "Download Request Created Successfully", "success");
    },
      (error) => {
        console.error('Error fetching huddle spotlight data:', error);
      }
    );
  }


  getActionList(): void {
    this.isLoading = true;
    this.isDataAvailable = false;
    const params = this.getParameterForFeedList()
    this.actionTable.rows = []
    this.feedMapping = {}
    this._feedService.getFeedsByFilter(params).subscribe((response: any) => {
      if (response && response.data && response.data.feed && !_.isEmpty(response.data.feed)) {
        this.actionTable.rows = this.prepareRowDetails(response.data.feed)
        let totalFeeds = response.data.total_feeds;
        let feedCount = (typeof totalFeeds === 'number') ? totalFeeds : totalFeeds.value;
        this.updatePagingDetails(feedCount, this.pagingDetails.pageNumber)
        this.isDataAvailable = true;
      } else {
        this.isDataAvailable = false
      }
      this.isLoading = false;
    },
      (error: any) => {
        this.isLoading = false;
        this.isDataAvailable = false;
        console.error('Error fetching huddle details:', error);
      }
    );
  }

  getParameterForFeedList() {
    var parameters = {
      "accountId": this.accountId,
      "brandId": this.actionBrandId,
      "limit": this.pagingDetails.pageSize,
      "pageNumber": this.pagingDetails.pageNumber,
      "dataSource": 2,
      "from": this.fromDate,
      "to": this.toDate,
      "dataSortOrder": _.get(this.filters, "sortOrder") || "desc",
      "searchType": (this.filters.textToSearch && this.filters.textToSearch != '') ? this.filters.fieldToSearchOn : null,
      "searchText": (this.filters.textToSearch && this.filters.textToSearch != '') ? this.filters.textToSearch : null,
      "hierarchyFilterDetailsList": this.hierarchyStack,
      "customFilterList": this.getCustomFilterList()
    };
    if(_.get(this.filters,"fieldToSortOn")){
      parameters["fieldToSortOn"] = this.filters["fieldToSortOn"];
      parameters["fieldSortOrder"] = this.filters["fieldSortOrder"];
      parameters["dataSortOrder"] = null;
    }
    return parameters;
  }

  prepareRowDetails(feedDetails) {
    var meetingRowData: any = {};
    var rowDetails: any = [];
    var dataEditiblityMode: boolean = false;
    var displayField: any = null;
    var valueField: any = null;

    if (feedDetails) {
      _.each(feedDetails, (feedData: any) => {
        if (!_.isEmpty(this.columns)) {
          var data: any = {};
          _.each(this.columns, (column: any) => {
            data['row_id'] = feedData._id;
            this.feedMapping[feedData._id] = feedData;
            data['key'] = feedData._id
            const colKey = column.field_id
            if (_.get(feedData, 'feedback_request_data')) {
              var feedbackRequestData = feedData.feedback_request_data;
              var litmusProcessedData = feedData.litmus_processed_data;
              data['meeting_id'] = _.get(feedbackRequestData, "tag_meeting_id") || _.get(litmusProcessedData, "tag_meeting_id");

              if (_.get(column, 'data_type') == 'date') {

                data[column.field_id] = moment(feedData.created_date);
                data[column.field_id] = data[column.field_id].format("DD-MMM-YYYY");

              } else {
                if (_.get(column, 'datasource.options.data_to_save_in.display_field') && _.get(column, 'datasource.options.data_to_save_in.value_field')) {
                  var datasourceOptions = column.datasource.options;
                  displayField = _.get(datasourceOptions, "data_to_save_in.display_field");
                  valueField = _.get(datasourceOptions, "data_to_save_in.value_field");

                  if (_.get(datasourceOptions, 'value_field') && _.get(datasourceOptions, 'display_field')) {
                    var dataToShow: any = [];
                    var tagdetail: any = {};

                    tagdetail[datasourceOptions.value_field] = data[valueField] = _.get(feedbackRequestData, valueField) || _.get(litmusProcessedData, valueField);
                    tagdetail[datasourceOptions.display_field] = data[displayField] = _.get(feedbackRequestData, displayField) || _.get(litmusProcessedData, displayField);

                    data[colKey] = feedbackRequestData[valueField] || litmusProcessedData[valueField];
                    data[colKey] = feedbackRequestData[displayField] || litmusProcessedData[displayField];

                    dataToShow.push(tagdetail);
                    feedbackRequestData[colKey] = dataToShow;
                    if (litmusProcessedData) {
                      litmusProcessedData[colKey] = dataToShow;
                    }
                  }
                } else {
                  data[colKey] = _.get(feedbackRequestData, colKey) || _.get(litmusProcessedData, colKey) || "NA";
                }

                // data[colKey] = _.get(feedbackRequestData, colKey) || _.get(litmusProcessedData, colKey) || "NA";
                // }
              }
            }

          });

          //Check for manager access wether edit button enable or not in huddle table reneder. 
          if (_.get(feedData, 'feedback_request_data')) {
            dataEditiblityMode = this.managerAccessCheck(feedData.feedback_request_data, this.managerAccess);
            if (dataEditiblityMode) {
              data['editable'] = true;
            } else {
              data['editable'] = false;
            }
            data["isReadOnly"] = true;
          }
          if (_.get(this.brandDetails, 'action_management_configuration.huddle.modules.actions.config.is_edit_btn')) {
            data["editBtn"] = "";
          }
          if (_.get(feedData, 'feedback_request_data.tag_meeting_name') || _.get(feedData, 'litmus_processed_data.tag_meeting_name')) {
            var meetingName = _.get(feedData, "feedback_request_data.tag_meeting_name") || _.get(feedData, "litmus_processed_data.tag_meeting_name");
            data["tag_meeting_name"] = (meetingName) ? meetingName.slice((meetingName.indexOf('-') + 1), meetingName.lastIndexOf('-')).trim() : 'NA';
          }
          rowDetails.push(data);
        }
      });
      return rowDetails;
    }
  }


  editActionDetail(row: any) {
    this.modalData = {
      "fieldDefinitionsForList": this.actionDetails.fieldDefinitions,
      "fieldDefinitions": this.columns,
      "brandDetails": _.get(this.actionDetails, "brand"),
      "issueDetail": this.feedMapping[row.row_id],
      "dataToEdit": row,
      "mode": "Update",
      'modalHeader': "Action Plan"
    }
    this.showEditModal = true
  }
  reloadActionList(event: any) {
    this.modalData = {}
    this.showEditModal = false;
    this.getActionList();
  }

  closeEditModal() {
    this.modalData = {}
    this.showEditModal = false;
  }

  cancelEdit() {
    this.modalData = {}
    this.showEditModal = false;
  }

  getSortedData(field: any) {
    const fieldDetail: any = _.find(this.columns, { field_id: field.uniqueId });
    if (fieldDetail && !_.isEmpty(fieldDetail)) {
      if (_.get(fieldDetail, "datasource.options.data_to_save_in.display_field")) {
        this.filters["fieldToSortOn"] = "litmus_processed_data." + _.get(fieldDetail, "datasource.options.data_to_save_in.display_field") + ".keyword";
        this.filters["fieldSortOrder"] = _.get(field, "sort_order");
        this.filters["sortOrder"] = null;
      }else{
        delete this.filters["fieldToSortOn"];
        delete this.filters["fieldSortOrder"];
        this.filters["sortOrder"] = _.get(field, "sort_order");
      }
      this.tableConfigs.defaultSortOnColumn = field;
      this.actionTable.fixedHeader = _.map(this.actionTable.fixedHeader,(column:any)=>{
        if(column.uniqueId == field.uniqueId){
          column.sort_order = _.get(field, "sort_order");
        }else{
         delete column.sort_order;
        }
        return column;
      })
      this.actionTable.header = _.map(this.actionTable.header,(column:any)=>{
        if(column.uniqueId == field.uniqueId){
          column.sort_order = _.get(field, "sort_order");
        }else{
         delete column.sort_order;
        }
        return column;
      })
      this.getActionList();
    }
  }
  managerAccessCheck(tagPrivateData, accessKeys) {
    let isAccessExist: boolean = false;
    _.each(accessKeys, (accessValues: any, key: string) => {
      if (tagPrivateData['tag_private_group_' + key] && accessValues['values'].indexOf(tagPrivateData['tag_private_group_' + key][0]) >= 0) {
        isAccessExist = true;
      }
    })

    return isAccessExist;
  }

  getManagerAccess(brandId) {
    const managerAccesses = _.get(Helpers, 'managerDetails.manager.manager_access', [])
    var accessDetails = _.filter(managerAccesses, function (accessDetails) {
      return (_.get(accessDetails, 'access_key') && _.get(accessDetails, 'brand_id') == brandId);
    });

    // let managerAccess = _.get(accessDetails[0], 'access_key');
    return _.get(accessDetails[0], 'access_key')
  }



  toggleFullScreen() {
    const doc = window.document;
    const docEl = doc.documentElement;

    const requestFullScreen =
      docEl.requestFullscreen ||
      docEl['webkitRequestFullscreen'] ||
      docEl['mozRequestFullScreen'] ||
      docEl['msRequestFullscreen'];

    const exitFullScreen =
      doc.exitFullscreen ||
      doc['webkitExitFullscreen'] ||
      doc['mozCancelFullScreen'] ||
      doc['msExitFullscreen'];

    if (!this.isFullScreen) {
      // Enter full screen mode
      if (requestFullScreen) {
        requestFullScreen.call(docEl);
      }
      this.isFullScreen = true;
    } else {
      // Exit full screen mode
      if (exitFullScreen) {
        exitFullScreen.call(doc);
      }
      this.isFullScreen = false;
    }
  }

  updatePagingDetails(totalfeeds: number, pageNumber: number) {
    if (totalfeeds > this.pagingDetails.pageSize) {
      pageNumber = (pageNumber > 0) ? pageNumber : 1;
      let start = (pageNumber > 0) ? ((pageNumber - 1) * this.pagingDetails.pageSize) + 1 : 1;
      let end = (pageNumber > 0) ? (pageNumber * this.pagingDetails.pageSize) : this.pagingDetails.pageSize;
      end = (pageNumber >= this.pagingDetails.totalpages) ? ((pageNumber - 1) * this.pagingDetails.pageSize) + this.actionTable.rows.length : end;
      this.pagingDetails = {
        start: start,
        end: end,
        pageSize: 10,
        pageNumber: pageNumber,
        total: totalfeeds,
        totalpages: Math.ceil(totalfeeds / 10)
      }
    } else {
      this.pagingDetails = {
        start: (totalfeeds > 0) ? 1 : 0,
        end: (totalfeeds > 0) ? totalfeeds : 0,
        pageSize: 10,
        pageNumber: 1,
        total: (totalfeeds > 0) ? totalfeeds : 0,
        totalpages: 1
      }
    }
    this.pagingDetails.total = totalfeeds;
    this.pagingButtons.isNext = false;
    this.pagingButtons.isFirst = false;
    this.pagingButtons.isPrevious = false;
    this.pagingButtons.isLast = false;

    if (this.pagingDetails.pageNumber < this.pagingDetails.totalpages) {
      this.pagingButtons.isNext = true;
      this.pagingButtons.isLast = true;
    }

    if (this.pagingDetails.pageNumber > 1) {
      this.pagingButtons.isFirst = true;
      this.pagingButtons.isPrevious = true;
    }

    if (this.pagingDetails.total < this.pagingDetails.pageSize) {
      this.pagingButtons.isNext = false;
      this.pagingButtons.isFirst = false;
      this.pagingButtons.isPrevious = false;
      this.pagingButtons.isLast = false;
    }
  }

  paginateFeedList(pagingType: string) {
    if (pagingType == 'next') {
      this.pagingDetails["pageNumber"]++;
    } else if (pagingType == 'previous') {
      this.pagingDetails["pageNumber"]--;
    } else if (pagingType == 'first') {
      this.pagingDetails["pageNumber"] = 1;
    } else if (pagingType == 'last') {
      this.pagingDetails["pageNumber"] = this.pagingDetails.totalpages;
    }
    this.getActionList()
  }

}